var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddToHomeScreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "40mm",
    height: "40mm",
    viewBox: "0 0 141.73228 141.73229",
    style: {
      stroke: "black",
      strokeWidth: 3
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-155.53095,-453.5347)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4894",
    transform: "translate(-4.0197975,4.4185)"
  }, /*#__PURE__*/React.createElement("rect", {
    ry: 23.523623,
    y: 463.96423,
    x: 174.79749,
    height: 112.03622,
    width: 111.23881,
    id: "rect4163",
    style: {
      fill: "none",
      fillOpacity: 1,
      strokeWidth: 5.0999999,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 1,
      strokeWidth: 5.9000001,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "rect4194",
    width: 61.785404,
    height: 61.984749,
    x: 199.52419,
    y: 488.98996,
    ry: 13.014595
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4196",
    d: "m 230.31722,507.32345 0.19935,25.3178",
    style: {
      fill: "none",
      strokeWidth: 5.9000001,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5.9000001,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 243.07579,519.88268 217.758,520.08203",
    id: "path4198"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddToHomeScreen);
export default __webpack_public_path__ + "static/media/add-to-home-screen.fd55280fffd906d2f3c8fdca2e58890c.svg";
export { ForwardRef as ReactComponent };